import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import IDealHeader from '@/finsight/ui/components/deals/DealsList/DealHeader/IDealHeader';

import styles from '@/finsight/ui/components/deals/DealsList/DealHeader/dealHeader.scss';

interface IRegionProps {
  deal: IDealHeader,
}

const Region = ({ deal }: IRegionProps) => (
  <div className={ styles.regionCol } data-test="dealRowRegions">
    <Tooltip content={ `Issuer Domicile: ${ deal.country.name }` }>
      <span className={ styles.region }>
        { deal.region.abbreviation }
      </span>
    </Tooltip>
  </div>
);

export default Region;
